import getMetricsPublisher from './katalMetricsPublisher';

const VIBES_URLS = {
    prod: {
        USAmazon: 'https://d1qhz7cfyjhrcf.cloudfront.net',
        EUAmazon: 'https://d2xz78i0uf24on.cloudfront.net',
        FEAmazon: 'https://d2uoea3f4olihz.cloudfront.net',
        'eu-south-2': 'https://d2xz78i0uf24on.cloudfront.net',
    },
    beta: {
        USAmazon: 'https://d1awn7zroxtggv.cloudfront.net',
        EUAmazon: 'https://d21qaigptwqi6g.cloudfront.net',
        FEAmazon: 'https://d1nkhofe5yzfzx.cloudfront.net',
        'eu-south-2': 'https://d21qaigptwqi6g.cloudfront.net',
    },
};

function publishFailureMetric(domain, region) {
    getMetricsPublisher()
        .newChildActionPublisherForMethod('LoadVibesScript')
        .publishCounterMonitor(`error.${domain}.${region}`, 1);
}

export function loadVibesScript(domain, region) {
    if (!VIBES_URLS[domain]) {
        publishFailureMetric(domain, region);
        throw new Error(`loadVibesScript: unknown domain="${domain}"`);
    }
    if (!VIBES_URLS[domain][region]) {
        publishFailureMetric(domain, region);
        throw new Error(`loadVibesScript: unknown region="${region}" for domain="${domain}"`);
    }

    const scriptEl = document.createElement('script');
    scriptEl.src = `${VIBES_URLS[domain][region]}/vibes_loader.latest.js`;
    document.head.appendChild(scriptEl);
}
